import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Fieldset, Legend, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input,
    Collapse, ButtonGroup
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect, withRouter } from "react-router-dom"
import apiResponse from '../../../../../services/apiResponse'

import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'
import IndexBloc from '../../Index/Blocs/IndexBloc_'

class TmtEndModal extends Component {
    indexBloc = new IndexBloc()
    timer
    source
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            dataForm: null
        }        
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }


    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, '')
        await this.indexBloc.fetchTMTEnd(dataForm)
    }

    componentDidMount() { 
        this.indexBloc.tmtEndChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        this.setState({
                            loading: false,
                            success: true,
                        }, function() {
                            this.props.handleReload()
                        });
                    } else {
                        this.setState({
                            loading: false,
                            failed: true,
                        });
                    }
                    this.props.toggle()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.modal} size='lg' centered={true} toggle={this.props.toggle}>
                    <ModalHeader toggle={this.props.toggle}>Edit TMT Berakhir</ModalHeader>
                    <ModalBody>
                        <AvForm
                            className="needs-validation"
                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                        >
                            <Row className="mb-3">
                                <Label
                                    className="col-md-3 col-form-label"
                                >
                                    TMT Berkahir <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <AvField 
                                        placeholder="TMT Berkahir.."
                                        name="employee_transfer_detail_tmt_date_end"
                                        type="date"
                                        validate={{ required: { value: true } }}
                                        value={this.props.tmtEndDate}
                                    />
                                </Col>
                            </Row>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>{' '}
                                <Button color="primary" type="submit">Submit</Button>
                            </ModalFooter>
                        </AvForm>
                    </ModalBody>
                </Modal>        

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />


            </Fragment>
        )
    }
}

export default TmtEndModal